// ProductItem.tsx - Updated version

import ProductConfigDisplay from "../../../Reusables/ProductConfigDisplay/ProductConfigDisplay"
import React, { useState } from "react"
import styles from "./ProductItem.module.css"
import { FaRegTrashCan } from "react-icons/fa6"
import { FaRegEdit } from "react-icons/fa"
import ProductPriceBreakdown from "../../../Reusables/ProductPriceBreakdown/ProductPriceBreakdown"
import { Tab, Tabs } from "react-bootstrap"

const ProductItem = ({
    productData,
    userSelection,
    imageUrl,
    product,
}) => {

    const displayPrice = product.displayPrice || product.selection_id?.displayPrice
    const selectedColorway = userSelection?.colorway

    

    return (
        <>
            <div className={`d-flex flex-column p-3 ${styles.windowProductItem}`}>
                <div className={`d-flex flex-row w-100 justify-content-between`}>
                    <div className={`d-flex`}>
                        <div className={styles.productImageContainer}>
                            <img
                                src={`https://tulio-staging.sgp1.digitaloceanspaces.com/${selectedColorway?.imageKey || imageUrl}`}
                                alt={productData?.name || "Product"}
                                className={styles.productThumbnail}
                                style={{
                                    height: "120px",
                                    width: "90px"
                                }}
                            />
                        </div>
                        <div>
                            <div className={styles.productCode}>
                                {productData?.category?.label}: {productData?.code || "N/A"}
                            </div>
                            <div className={styles.productName}>{productData?.name}</div>
                            {selectedColorway && (
                                <div className={styles.selectedColorway}>
                                    <span
                                        className={styles.colorSwatch}
                                        style={{
                                            backgroundColor: `#${selectedColorway.code || "CCCCCC"}`
                                        }}
                                        title={`${selectedColorway.name}`}
                                    />
                                </div>
                            )}
                            <div className={``}>
                                <span className={`mx-3`}>{userSelection.quantity}</span>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column justify-content-between align-items-end">

                        <div className={styles.productPrice}>
                            {displayPrice?.formatted}
                        </div>
                    </div>
                </div>
                <span
                    style={{
                        width: "100%",
                        height: "1px",
                        backgroundColor: "#ddd",
                        margin: "10px 0px"
                    }}
                ></span>
                <div className={styles.productInfo}>
                    <Tabs
                        defaultActiveKey="config"
                        id="uncontrolled-tab-example"
                    >
                        <Tab className="pt-2" eventKey="config" title="Configuration">
                            <ProductConfigDisplay
                                productType={productData?.category?.productType}
                                userSelection={userSelection}
                            />
                        </Tab>
                        <Tab className="pt-2" eventKey="breakdown" title="Price Breakdown">
                            <ProductPriceBreakdown
                                priceComponent={product?.priceComponents}
                                costPriceComponent={product?.costPriceComponents}
                                priceTypeEnabled={true}
                            />
                        </Tab>
                    </Tabs>

                </div>
            </div>
        </>
    )
}

export default ProductItem
